import 'jsonform'
import Notify from './../shared/notify'


var RenderForm = (id) => {

  var $form = $('<form class="is-loading"></form>');
  $('#form-' + id).after($form);
  
  // Get the form data from the api endpoint
  $.get('/api/form/'+id).done((data) => {
    $form.removeClass('is-loading');
   
    var schema = JSON.parse(data.jsonSchema);
    var options = JSON.parse(data.formOption);
    var initValues = Object.fromEntries(new URL(document.location.toString()).searchParams);
    var formId = data.id;
    var $errors = $('<div class="jsonform-errors" style="display:none;"></div>');
    $form.before($errors);
    var urlPost = '/api/form';

    // Render the form with the jsonForm lib
    $form.jsonForm({
      schema: schema,
      value: initValues,
      form: options,
      onSubmitValid: function (values) {
        console.log(values);
      },
      onSubmit: function (errors, values) {
        $errors.hide();
        $errors.html('');
        if (!errors) {
          $.post(urlPost, { values: JSON.stringify(values), formId: formId })
            .done(function (data) {
              if (data.messageResult)
                $form.html(data.messageResult); 
            })
            .fail(function(err) {
              console.log(err);
              if (err.status == 400){
                for (var key in err.responseJSON) {
                  appendError(err.responseJSON[key][0]);
                }
              } else
                appendError('Erreur de type inconnu');
            });
        } else {
          appendError('"Le formulaire n\'est pas correctement rempli');
        }
        return false;
      }
    });

    function appendError(message){
      $errors.show();
      $errors.append('<div class="jsonform-error-item">'+message+ '</div>');
    }

    // Add the class row
    $form.children('div').addClass('row');

    //permet de transformer la propriété "description" en placeholder
    $(".help-block").each(function (i, el) {
      var placeholder = $(el).text();
      if (placeholder != "") {
        var $input = $(el).closest(".controls").find("input, textarea");
        if ($input.length != 0) {
          $input.attr("placeholder", placeholder);
          $(el).hide();
        }
      }
    });
  });
}


export default RenderForm
